import { Layout } from '@hcrshubham/core-components';
import { en } from '@hcrshubham/i18n';
import { useTheme } from 'next-themes';
import Link from 'next/link';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { NextSeo } from 'next-seo';
import { useEffect, useState } from 'react';

const BioPage = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { theme, systemTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  const siteUrl = (process.env.NEXT_PUBLIC_SITE_URL || 'https://shubhamsharma.in').replace(/\/$/, '');

  // Ensure theme is resolved on client (prevents hydration issue)
  useEffect(() => {
    setMounted(true);
  }, []);

  // 🔥 FORCE PDF LINKS TO OPEN IN NEW TAB
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a') as HTMLAnchorElement | null;

      if (anchor && anchor.href) {
        anchor.target = '_blank';
        anchor.rel = 'noopener noreferrer';
      }
    };

    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  if (!mounted) return null;

  // Resolve actual theme
  const resolvedTheme =
    theme === 'system' ? systemTheme : theme;

  return (
    <>
      <NextSeo
        title="Resume - Shubham Kumar Sharma"
        description="View or download the resume of Shubham Kumar Sharma, Full Stack Java Developer."
        canonical={`${siteUrl}/resume`}
      />

      <Layout wrapperClass="main-aboutpage">
        <section className="about-area-resume">
          <h1 className="section-heading" data-aos="fade-up">
            <img src="/assets/star-2.png" alt="star" /> Resume{' '}
            <img src="/assets/star-2.png" alt="star" />
          </h1>

          <div className="container">
            <div style={{ textAlign: 'center', marginBottom: 12 }}>
              <a href="/Resume.pdf" download className="theme-btn">
                Download Resume
              </a>
            </div>

            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
              <Viewer
                fileUrl="/Resume.pdf"
                plugins={[defaultLayoutPluginInstance]}
                theme={resolvedTheme === 'dark' ? 'dark' : 'light'} // ✅ DARK MODE DEFAULT
              />
            </Worker>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default BioPage;
